module.exports = __webpack_public_path__ + "static/img/cwy46.3c047f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cwy46.png
// module id = CGvF
// module chunks = 73